import React from 'react';

import PropTypes from 'prop-types';

import LearnMoreInfoPill from 'components/application/pills/LearnMoreInfoPill';
import NewInfoPill from 'components/application/pills/NewInfoPill';

import OpenInNewIcon from '-!svg-react-loader?name=OpenInNewIcon!icons/open-in-new.svg';

export default function InfoCardLink({ children, label, title, url }) {
  return (
    <a
      className='tw-relative tw-flex tw-max-w-[400px] tw-flex-col tw-gap-2 tw-rounded-lg tw-border-1 tw-border-solid tw-border-grey-300 tw-bg-white tw-p-5 hover:tw-border-blue-300'
      href={url}
      rel='noreferrer'
      target='_blank'
    >
      {['learnMore', 'new'].includes(label) && (
        <div className='tw-absolute -tw-top-3 tw-left-2'>
          {label === 'learnMore' ?
            <LearnMoreInfoPill />
          : <NewInfoPill />}
        </div>
      )}
      <div className='tw-flex tw-items-center tw-justify-between'>
        <div className='tw-text-m tw-font-semibold tw-text-grey-900'>
          {title}
        </div>
        <OpenInNewIcon height={16} width={16} />
      </div>
      {children}
    </a>
  );
}

InfoCardLink.propTypes = {
  children: PropTypes.node,
  label: PropTypes.oneOf(['learnMore', 'new']),
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
